
import { defineComponent } from 'vue';
import utils from '@/utils';
import api from '@/api/admin/utilities';

export default defineComponent({
  methods: {
    btnClearCacheClick() {
      utils.alertDelete(
        {
          title: '清除缓存',
          text: '此操作将清除缓存，确定吗？',
          button: '确定清除',
        },
        () => {
          api.clearCache((res) => {
            if (!res.value) return;
            utils.success('清除缓存成功！');
          });
        },
      );
    },

    btnCreateWeChatMenusClick() {
      utils.alertDelete(
        {
          title: '同步微信菜单',
          text: '此操作将同步微信菜单，确定吗？',
          button: '确定同步',
        },
        () => {
          api.createWeChatMenus((res) => {
            if (!res.success) {
              utils.error(res.errorMessage);
            } else {
              utils.success('微信菜单同步成功！');
            }
          });
        },
      );
    },

    btnSyncClick() {
      utils.alertDelete(
        {
          title: '同步数据结构',
          text: '此操作将同步数据结构，确定吗？',
          button: '确定同步',
        },
        () => {
          api.syncDatabase((res) => {
            if (!res.value) return;
            utils.success('数据结构同步成功！');
          });
        },
      );
    },
  },
});
